/**
 * Category types matching backend CategoryType enum
 */
export enum CategoryType {
	EDUCATIONAL_RESOURCE = "EDUCATIONAL_RESOURCE",
	TAMPERED_REASON = "TAMPERED_REASON",
	/** SIMS-8634 — payer categories separate real payers from test records. */
	PAYER_CATEGORY = "PAYER_CATEGORY",
}

/**
 * Category status matching backend CategoryStatus enum
 */
export enum CategoryStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}

/**
 * Language-specific category content
 */
export interface CategoryLanguage {
	_id: string;
	language: string;
	name: string;
	description?: string;
}

/**
 * Individual category item within a category document
 */
export interface CategoryItem {
	_id: string;
	languages: CategoryLanguage[];
	status: CategoryStatus;
}

/**
 * Category document structure
 */
export interface Category {
	_id: string;
	account: string;
	categories: CategoryItem[];
	status: CategoryStatus;
	type: CategoryType;
	createdBy?: string;
	createdAt?: string;
	updatedAt?: string;
}

/**
 * API response wrapper for category
 */
export interface CategoryResponse {
	body: Category;
	statusCode: number;
}
